"use client";

import FadeIn from "@components/shared/loading/FadeIn";
import { Box, Link, Typography, styled } from "@mui/material";

const Root = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "calc(100vh - 146px)",
  gap: "1rem",
});

const ImageContainer = styled(Box)({
  width: "280px",
  height: "280px",
  marginTop: "2rem",

  "& img": {
    width: "100%",
    height: "100%",
  },
});

const BodyText = styled(Typography)({
  width: "60%",
  margin: "0 auto",
  textAlign: "center",
});

export default function SolaPlaceholder() {
  return (
    <FadeIn>
      <Root>
        <ImageContainer>
          <img src="/img/floats/sola.svg" alt="SOLA" />
        </ImageContainer>
        <BodyText variant="body1" component="p">
          SOLA is available on paid accounts on request.
          <br />
          Contact <Link href="mailto:support@floats.ai">
            support@floats.ai
          </Link>{" "}
          for more details.
        </BodyText>
      </Root>
    </FadeIn>
  );
}
